import api from "./api";

const BASE = "/encryption";

export const encryptText = async (plainText) =>
    (
        await api.post(
            `${BASE}/encrypt`,
            JSON.stringify(plainText),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
    ).data;

export const decryptText = async (encryptedText) =>
    (
        await api.post(
            `${BASE}/decrypt`,
            JSON.stringify(encryptedText),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
    ).data;

export const generateKeys = async () =>
    (
        await api.post(`${BASE}/generate-keys`)
    ).data;

export default {
    encryptText,
    decryptText,
    generateKeys,
};